import { AzureVmTableData, VmssTableData } from './types';
import {
  AzureVmResourceDetails,
  VmssResourceDetails,
} from '@internal/backstage-plugin-compute-resource-discovery-new-common';

export const mapResourcesToAzureVmTableData = (
  resources: AzureVmResourceDetails[],
): AzureVmTableData[] => {
  return resources.map(resource => {
    const baseData = {
      identifier: resource.identifier,
      name: resource.name,
      state: resource.state,
      size: resource.size,
      resourceGroup: resource.resourceGroup,
    };
    return baseData;
  });
};

export const mapResourcesToVmssTableData = (
  resources: VmssResourceDetails[],
): VmssTableData[] => {
  return resources.map(resource => {
    const baseData = {
      identifier: resource.identifier,
      name: resource.name,
      location: resource.location,
      resourceGroup: resource.resourceGroup,
      sku: resource.sku,
      capacity: resource.capacity,
      instanceCount: resource.instanceCount,
      status: resource.status,
    };
    return baseData;
  });
};
